import { getAnalytics, logEvent, setUserProperties } from 'firebase/analytics';
import { app } from '@cvt/clients/firebaseClient';
import Hotjar from '@hotjar/browser';

const analytics = getAnalytics(app);

const hasContentSquare = import.meta.env.VITE__CVT_CONTENTSQUARE_ID !== '';
const hasHotjar = !!import.meta.env.VITE__CVT_HOTJAR_HJID && !!import.meta.env.VITE__CVT_HOTJAR_HJSV;

if (hasHotjar) {
  Hotjar.init(import.meta.env.VITE__CVT_HOTJAR_HJID, import.meta.env.VITE__CVT_HOTJAR_HJSV);
}

if (hasContentSquare) {
  const contentSquareScript = document.createElement('script');
  const contentSquareId = import.meta.env.VITE__CVT_CONTENTSQUARE_ID || '7e7ae93c15586';
  contentSquareScript.src = `https://t.contentsquare.net/uxa/${contentSquareId}.js`;
  contentSquareScript.async = true;
  document.head.appendChild(contentSquareScript);
}
export const trackPageview = () => {
  logEvent(analytics, 'page_view', {
    page_path: window.location.pathname,
    page_title: document.title,
    page_location: window.location.href,
  });
};

export const trackSignUp = () => {
  logEvent(analytics, 'sign_up', {
    content_type: 'user',
  });
};

export const trackLogIn = () => {
  logEvent(analytics, 'login', {
    content_type: 'user',
  });
};

export const setUserEmailDimension = (email: string) => {
  setUserProperties(analytics, { email });
};

export const setUserCompanyDimension = (company: string) => {
  setUserProperties(analytics, { company });
};
